export default "__VITE_ASSET__CT3hdyS1__"